'use client';

import { useMemo } from 'react';
import { useGetPermissions } from '@practium/features/api';
import {
	parsePermissions,
	deriveBindingUsersPermissions,
	deriveRoutePermissions,
} from '../utils/parsePermissions';
import type {
	ParsedAbilities,
	BindingUsersPermissionsFromAbility,
	RoutePermissions,
} from '../utils/parsePermissions';

export const usePermissions = (
	options: { enabled?: boolean } = {}
): {
	abilities: ParsedAbilities;
	bindingUsersPermissions: BindingUsersPermissionsFromAbility;
	routePermissions: RoutePermissions;
	isLoading: boolean;
} => {
	const { data: permissions, isLoading } = useGetPermissions(options);

	const abilities = useMemo(() => parsePermissions(permissions ?? []), [permissions]);

	const bindingUsersPermissions = useMemo(
		() => deriveBindingUsersPermissions(abilities),
		[abilities]
	);

	const routePermissions = useMemo(() => deriveRoutePermissions(abilities), [abilities]);

	return { abilities, bindingUsersPermissions, routePermissions, isLoading };
};
